import { Box, Button } from '@mui/material'
import React from 'react'

const HeaderLogo = (props) => {
  return (
    <Button
      aria-label="Personal Architect"
      href="/"
      sx={{alignItems: "center", display: "flex", m:0, p:0, minWidth: 0, minHeight: 0, }}
    >
      {
        !props.isMobile ? (
          !props.isAppBarHovered ? (
            <Box
              alt="Personal Architect"
              component="img"
              src={
                process.env.NODE_ENV === 'development' ? 
                  "/assets/svg/logos/white/personal-architect-horizontal.svg" : 
                  "/wp-content/themes/personal-architect/assets/svg/logos/white/personal-architect-horizontal.svg"
              }
              sx={{width: 220, height: 36.15,}}
            />
          ) : (
            <Box
              alt="Personal Architect"
              component="img"
              src={
                process.env.NODE_ENV === 'development' ? 
                  "/assets/svg/logos/primary/personal-architect-horizontal.svg" : 
                  "/wp-content/themes/personal-architect/assets/svg/logos/primary/personal-architect-horizontal.svg"
              }
              sx={{width: 220, height: 36.15,}}
            />
          )
        ) : (
          !props.isAppBarHovered ? (
            <Box
              alt="Personal Architect"
              component="img"
              src={
                process.env.NODE_ENV === 'development' ? 
                  "/assets/svg/marks/white/personal-architect.svg" : 
                  "/wp-content/themes/personal-architect/assets/svg/marks/white/personal-architect.svg"
              }
              sx={{width: 40, height: 36.15,}}
            />
          ) : (
            <Box
              alt="Personal Architect"
              component="img"
              src={
                process.env.NODE_ENV === 'development' ? 
                  "/assets/svg/marks/primary/personal-architect.svg" : 
                  "/wp-content/themes/personal-architect/assets/svg/marks/primary/personal-architect.svg"
              }
              sx={{width: 40, height: 36.15,}}
            />
          )

        )
      }
    </Button>
  )
}

export default HeaderLogo